import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Popover, Position, PopoverInteractionKind} from "@blueprintjs/core";
import toastr from 'toastr';

//import {Link} from 'react-router-dom';

class PostsListRow extends Component {

    state = {
        details: "none", platformsEnabled: this.props.platformsEnabled, user: this.props.user, post: this.props.post
    };


    toggleDetails = (selected_src_info) => {
        if (this.state.details === "none") {
            this.setState({details: "block"})
        } else {
            this.setState({details: "none"})
        }
    };

    componentDidUpdate = async () => {
        if (this.state.platformsEnabled !== this.props.platformsEnabled) {
            await this.setState({
                platformsEnabled: this.props.platformsEnabled
            })
        }
        if (this.state.details !== this.props.detailsGlobal) {
            this.setState({details: this.props.detailsGlobal});
        }
        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
        }
        if (this.state.post !== this.props.post) {
            this.setState({
                post: this.props.post
            })
        }
    }

    copyToClipboard = (str) => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        toastr.success('Link: ' + str + ' is successfully copied to clipboard.')
    };


    componentDidMount = () => {
        this.setState({details: this.props.detailsGlobal});
    }


    render() {
        let post = this.props.post;
        const details = this.state.details;
        var prefix = 'USER-';

        let ribbon_vip = <span className="text-center far fa-calendar-check"></span>;

        ribbon_vip = (post.name.startsWith(prefix)) ? ribbon_vip : "";

        let details_data = {};

        if (post.data) {
            details_data = post.data;
        }

        let image_url = post.image || "https://www.worldbookday.com/wp-content/uploads/2017/09/LATEST-NEWS.jpg";

        return (<div className="post-container">
            <div className="post-card">
                <div className="post-picture"
                     style={{
                         backgroundImage: "url(" + image_url + ")",
                         height: "200px",
                         backgroundSize: "cover",
                         backgroundPosition: "enter",
                         backgroundRepeat: "no-repeat"
                     }}>

                    {/*<div id="post-1" className="post-channel-details" style={{display: 'block'}}>*/}

                    <div id="post-1" className="post-channel-details" style={{display: details}}>
                        <table>
                            <tbody>
                            <tr>
                                <th>Distribution Channels</th>
                                <th>Sent</th>
                                <th>Opened</th>
                                <th>Open rate</th>
                            </tr>
                            {details_data.facebook_pages && details_data.facebook_pages.map((page, index) => <tr
                                key={index}>
                                <td><span className="fab fa-facebook-messenger"></span>{page.page}</td>
                                <td>{page.sent_post}</td>
                                <td>{page.opened_post}</td>
                                <td>{page.percent_post}</td>
                            </tr>)}
                            <tr>
                                <td><span className="fas fa-globe"></span>WebPush</td>
                                <td>{details_data.sent_wp_post_total}</td>
                                <td>{details_data.opened_wp_post_total}</td>
                                <td>{details_data.percent_wp_post_total}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    {ribbon_vip}
                </div>
                <div className="post-info">

                    <a id="" target="_blamk" href={post.short_url} className="text-bold ">
                        <p className="post-title"
                           style={{minHeight: "60px"}}>{post.title ? post.title.slice(0, 200) : ""}</p>
                    </a>
                    <div>
                        <div className="post-details row ">
                            <div className="col-xs-12 label">Published</div>

                            <div
                                className="col-xs-12 date">{post.published_at ? (post.published_at.date ? post.published_at.date : post.published_at) : post.updated_at}</div>

                        </div>
                        <div className="post-footer-container">
                            <div onClick={() => this.copyToClipboard(post.short_url)}>
                                <i className="fas fa-link type-icon"></i>
                            </div>
                            <Popover
                                ref={menu => this.menuItem = menu}
                                position={Position.BOTTOM}
                                interactionKind={PopoverInteractionKind.CLICK}
                                className='profile-popover'
                                isOpen={this.state.isOpen}
                            >
                                <button className='btn-action'>Start Campaign</button>
                                {this.state.platformsEnabled ? <div className="flex-column padding-10">

                                    <a href='#' onClick={() => this.props.history.push('/new/sms', {post})}>Sms
                                        Campaign</a>

                                    {

                                        this.state.platformsEnabled.includes('vib') ?

                                            <a href='#'
                                               onClick={() => this.props.history.push('/new/viber', {post})}>Viber</a> : ''}

                                    {this.state.platformsEnabled.includes('wp') ? <a href='#'
                                                                                     onClick={() => this.props.history.push('/new/web-push', {post})
                                                                                         //console.log('webpush click post: ', post)
                                                                                     }>Web
                                        Push</a> : ''}
                                    {this.state.platformsEnabled.includes('fb') ? <a href='#'
                                                                                     onClick={() => this.props.history.push('/new/messenger', {post})}>Messenger
                                    </a> : ''}


                                </div> : ''}
                            </Popover>
                            {/*<div className="start-campaign-button" onClick={()=>this.props.history.push({*/}
                            {/*    pathname: '/new',*/}
                            {/*    state: { post }*/}
                            {/*})}>*/}
                            {/*    <p>Start Campaign</p>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>

            </div>
        </div>);
    }
}

//PostsListRow.propTypes = {
//    post: PropTypes.object.isRequired
//};

export default PostsListRow;

